export const decisionTool = {
  decisionTool: "Decision Support Tool",
  guidelines: {
    header: "Guidelines",
    guidelinesPre: "Here are some guidelines befor using this tool:",
    guidelines1:
      "The decision support tool provides a simplified visualization of the parts of an image that have the greatest influence on the suggestion model's decision (saliency map). However, it does not always accurately represent the complex reasoning behind the model's predictions.",
    guidelines2:
      "The tool may generate different masks for the same image, as the technique used is stochastic in nature.",
    guidelines3:
      "Suggestion and decision support tool results may differ since the decision tool produces a mask for one image at a time, while the suggestions are the average of the predictions for all the images.",
    guidelines4:
      "Some defects are not represented since their confidence level is too low.",
  },
  notice: {
    header: "Notice",
    noticeText:
      "Classification models can provide valuable information, but it is important to recognize their limitations and interpret results with caution, especially in complex or high-stakes scenarios.",
  },
};
